import { z } from 'zod'
import * as validation from '@/helpers/validation'

export const ListedTariffSchema = z.object({
  Id: z.number().int().gt(0),
  Name: z.string()
})

export const TariffsSchema =
        z.array(z.object({
          Id: validation.id(),
          ExternalId: z.string().nullable(),
          Name: z.string(),
          UtilityProviderId: z.number(),
          UtilityProviderName: z.string(),
          TimeOfUseProfileId: z.number(),
          ProvinceId: z.number(),
          ProvinceName: z.string(),
          IsTimeOfUse: z.boolean(),
          TransZone: z.string().nullable(),
          Voltage: z.string().nullable(),
          Source: z.string(),
          ApprovedBy: z.string(),
          CreatedAt: z.coerce.date(),
          UpdatedAt: z.coerce.date(),
          Periods: z.array(z.object({
            Id: validation.id(),
            ChargeNameId: z.number(),
            ChargeName: z.string(),
            SeasonId: z.number(),
            Season: z.string(),
            TimeOfUseId: z.number(),
            TimeOfUse: z.string(),
            IsActive: z.boolean(),
            YearOfTariff: z.string(),
            StartOfPeriod: z.number(),
            EndOfPeriod: z.number(),
            RateInCents: z.number(),
            OldRateInCents: z.number().nullable(),
            RateChangePercentage: z.number().nullish()
          })).min(1),
          IsApproved: z.boolean()
        }))

    export const UtilityProvidersSchema = z.array(z.object({
              Id: z.number().int().gt(0),
              Name: z.string()
            }))
